type Props = {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ kicker, title, desc, align = "left" }: Props) {
  const centered = align === "center";
  return (
    <div className={`${centered ? "mx-auto text-center" : ""} max-w-2xl`}>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700 ${
          centered ? "" : ""
        }`}
      >
        <i className="ri-leaf-line"></i>
        {kicker}
      </span>
      <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-6 text-foreground-700">{desc}</p>}
    </div>
  );
}